import { ReactElement, ReactNode } from 'react';
import cx from 'clsx';
import { Box, Sprinkles } from '@ff-it/ui';
import * as style from './style.css';

export type TitleContainerProps = {
  className?: string;
  testId?: string;
  title?: ReactNode;
  subtitle?: ReactNode;
  children?: ReactNode;
  htmlTitle?: string;
  disabled?: boolean;
  flat?: boolean;
  style?: React.CSSProperties;
  size?: style.Size;
} & Sprinkles;

export function TitleContainer({
  title,
  subtitle,
  children,
  className,
  testId,
  htmlTitle,
  flat,
  disabled,
  size,
  ...rest
}: TitleContainerProps): ReactElement {
  return (
    <Box
      className={cx(style.container, className, flat ? style.flat : undefined, disabled ? style.disabled : undefined)}
      data-testid={testId}
      title={htmlTitle}
      {...rest}
    >
      {title && <Title size={size}>{title}</Title>}
      {subtitle && <SubTitle size={size}>{subtitle}</SubTitle>}
      {children}
    </Box>
  );
}

type TitleProps = {
  className?: string;
  children: ReactNode;
  testId?: string;
  size?: style.Size;
  title?: string;
};

export function Title({ children, className, testId = 'title', size = 'xs', title }: TitleProps): ReactElement {
  return (
    <Box data-testid={testId} className={cx(style.title, style.titleSizeVariants[size], className)} title={title}>
      {children}
    </Box>
  );
}

export function SubTitle({ children, className, testId = 'subtitle', size = 'xs', ...rest }: TitleProps): ReactElement {
  return (
    <Box data-testid={testId} className={cx(style.subtitle, style.subTitleSizeVariants[size], className)} {...rest}>
      {children}
    </Box>
  );
}
